import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_3 = { class: "flex flex-wrap justify-center items-center sm:gap-10 flex-col sm:flex-row" }
const _hoisted_4 = {
  key: "countdown",
  class: "gap-4"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: "expired" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["href", "title"]
const _hoisted_12 = {
  key: 1,
  class: "c-countdown"
}
const _hoisted_13 = {
  key: "countdown",
  class: "mb-30"
}
const _hoisted_14 = {
  key: 0,
  class: "c-countdown__title"
}
const _hoisted_15 = { class: "c-countdown__numbers" }
const _hoisted_16 = { class: "c-countdown__number" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "c-countdown__spacer" }, ":", -1)
const _hoisted_18 = { class: "c-countdown__number" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "c-countdown__spacer" }, ":", -1)
const _hoisted_20 = { class: "c-countdown__number" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "c-countdown__spacer" }, ":", -1)
const _hoisted_22 = { class: "c-countdown__number" }
const _hoisted_23 = { class: "c-countdown__texts" }
const _hoisted_24 = { class: "c-countdown__text" }
const _hoisted_25 = { class: "c-countdown__text" }
const _hoisted_26 = { class: "c-countdown__text c-countdown__text--small" }
const _hoisted_27 = { class: "c-countdown__text c-countdown__text--large" }
const _hoisted_28 = { class: "c-countdown__text c-countdown__text--small" }
const _hoisted_29 = { class: "c-countdown__text c-countdown__text--large" }
const _hoisted_30 = { key: "expired" }
const _hoisted_31 = {
  key: 0,
  class: "c-countdown__title mb-30"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkButton = _resolveComponent("LinkButton")!

  return (_openBlock(), _createBlock(_Transition, { name: "o-anim-fade-300" }, {
    default: _withCtx(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.smallView)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    (!_ctx.pastTime && _ctx.title)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass({'font-bold': _ctx.titleBold})
                        }, _toDisplayString(_ctx.title), 3))
                      : _createCommentVNode("", true),
                    (!_ctx.pastTime)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          (_ctx.days)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.days) + " " + _toDisplayString(_ctx.$dictionary.get('global/generic/days')) + " - ", 1))
                            : _createCommentVNode("", true),
                          (_ctx.hours)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.hours) + " " + _toDisplayString(_ctx.$dictionary.get('global/generic/hours')) + " - ", 1))
                            : _createCommentVNode("", true),
                          (_ctx.minutes)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.minutes) + " " + _toDisplayString(_ctx.$dictionary.get('global/generic/min')) + ". - ", 1))
                            : _createCommentVNode("", true),
                          (_ctx.seconds)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.seconds) + " " + _toDisplayString(_ctx.$dictionary.get('global/generic/sec')) + ".", 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          (_ctx.expiredText)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.expiredText), 1))
                            : _createCommentVNode("", true)
                        ])),
                    (_ctx.link && _ctx.link.url)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 3,
                          class: "underline flex items-center",
                          href: _ctx.link.url,
                          title: _ctx.link.title
                        }, _toDisplayString(_ctx.link.text || _ctx.link.title), 9, _hoisted_11))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_Transition, {
                    name: "o-anim-fade-300",
                    mode: "out-in"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.pastTime)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_ctx.title)
                              ? (_openBlock(), _createElementBlock("h1", _hoisted_14, _toDisplayString(_ctx.title), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("h2", _hoisted_15, [
                              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.days), 1),
                              _hoisted_17,
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.hours), 1),
                              _hoisted_19,
                              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.minutes), 1),
                              _hoisted_21,
                              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.seconds), 1)
                            ]),
                            _createElementVNode("p", _hoisted_23, [
                              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$dictionary.get('global/generic/days')), 1),
                              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$dictionary.get('global/generic/hours')), 1),
                              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$dictionary.get('global/generic/min')), 1),
                              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$dictionary.get('global/generic/minutes')), 1),
                              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$dictionary.get('global/generic/sec')), 1),
                              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$dictionary.get('global/generic/seconds')), 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            (_ctx.expiredText)
                              ? (_openBlock(), _createElementBlock("h1", _hoisted_31, _toDisplayString(_ctx.expiredText), 1))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _: 1
                  }),
                  (_ctx.link && _ctx.link.url)
                    ? (_openBlock(), _createBlock(_component_LinkButton, {
                        key: 0,
                        link: _ctx.link
                      }, null, 8, ["link"]))
                    : _createCommentVNode("", true)
                ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}